import * as yup from "yup"

export const max = {
  fullname: [50, "ניתן להזין עד 50 תווים"] as [number, string],
}

export const required = {
  default: "שדה זה הינו שדה חובה",
  firstName: "יש להזין שם פרטי",
  lastName: "יש להזין שם משפחה",
  phoneNumber: "יש להזין מספר טלפון",
  licenseNumber: "יש להזין לוחית רישוי",
  licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
  modelId: "בחר דגם",
  area: "בחר איזור",
  skuOrName: "נא הכנס טקסט חופשי או מספר פריט",
}

export const regex = {
  numbers: /^[0-9]*$/,
  singleName: /^([a-zA-Zא-ת'"\\.\-,\s]+)$/,
  fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
  name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  licenseNumber:
    /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
  licenceOrChassis:
    /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/,
}

export const invalid = {
  numbers: "יש להזין ספרות בלבד",
  fullName: "שם מלא לא תקין",
  name: "יש להזין אותיות בעברית / אנגלית בלבד",
  email: "כתובת המייל אינה תקינה",
  phoneNumber: "מספר הטלפון אינו תקין",
  licenseNumber: "נא להזין מספר בעל 7-8 תווים המורכב מספרות בלבד",
  licenceOrChassis: "מספר רישוי או שילדה לא תקין",
}

export const schemaCommon = {
  phoneNumber: yup
    .string()
    .matches(regex.phoneNumber, "יש להזין מספר נייד תקין")
    .length(10, "יש להזין מספר נייד תקין")
    .required("יש להזין מספר נייד תקין")
    .max(10, "יש להזין עד 10 ספרות בלבד"),
  firstName: yup
    .string()
    .matches(regex.singleName, "יש להזין אותיות בלבד")
    .min(2, "יש להזין לפחות שתי אותיות תחת השם")
    .max(40, "יש להזין עד 40 תווים בלבד")
    .required(required.default),
  lastName: yup
    .string()
    .matches(regex.singleName, "יש להזין אותיות בלבד")
    .min(2, "יש להזין לפחות שתי אותיות תחת השם")
    .max(80, "יש להזין עד 80 תווים בלבד")
    .required(required.default),
  fullName: yup
    .string()
    .matches(regex.fullName, "יש להזין אותיות בלבד")
    .required(required.default),
  email: yup
    .string()
    .email("יש להזין כתובת מייל תקינה")
    .max(80, "יש להזין עד 80 תווים בלבד")
    .required(required.default),
  city: yup.string(),
  street: yup.string(),
  apartmentNumber: yup.string().matches(regex.numbers, invalid.numbers),
  floorNumber: yup.string().matches(regex.numbers, invalid.numbers),
  entranceNumber: yup.string().matches(regex.numbers, invalid.numbers),
  comments: yup.string(),
}
